import { cn } from '@/utils/cn';

import styles from './Skeleton.module.css';

export interface SkeletonProps {
  /** Width as a share of the line, e.g. "60%". */
  width?: string;
  className?: string | undefined;
}

/** One grey placeholder line that pulses while its content loads. */
export function Skeleton({ width, className }: SkeletonProps) {
  return (
    <span
      className={cn(styles.line, className)}
      style={width ? { width } : undefined}
      aria-hidden="true"
    />
  );
}

export interface SkeletonListProps {
  /** How many placeholder rows. */
  rows?: number;
  /** Read out to screen readers in place of the grey rows. */
  label?: string;
  className?: string | undefined;
}

/** Placeholder rows shaped like a list of people or items: a circle and two lines each. */
export function SkeletonList({ rows = 3, label = 'Loading…', className }: SkeletonListProps) {
  return (
    <div className={cn(styles.list, className)} role="status" aria-live="polite">
      <span className={styles.label}>{label}</span>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className={styles.row} aria-hidden="true">
          <span className={styles.circle} />
          <span className={styles.text}>
            <Skeleton width={index % 2 === 0 ? '55%' : '40%'} />
            <Skeleton width={index % 2 === 0 ? '80%' : '65%'} className={styles.thin} />
          </span>
        </div>
      ))}
    </div>
  );
}
